import React from 'react';
import { Switch } from 'tea-component';
import type { IMemorySwitchSectionProps } from '../../types';

const MemorySwitchSection: React.FC<IMemorySwitchSectionProps> = ({
  label,
  description,
  enabled,
  onToggle,
}) => (
  <div className="dba-memory-switch-block">
    <div className="dba-memory-switch-section">
      <span className="dba-memory-switch-label">{label}</span>
      <Switch
        value={enabled}
        onChange={onToggle}
      />
    </div>
    <p className="dba-memory-switch-desc">{description}</p>
  </div>
);

export default MemorySwitchSection;
